/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConnectionNode
 */
export interface ConnectionNode {
    /**
     * The name of the organization
     * @type {string}
     * @memberof ConnectionNode
     */
    organizationName?: string;
    /**
     * Unique ID for the organization
     * @type {string}
     * @memberof ConnectionNode
     */
    organizationId?: string;
    /**
     * A label for the entity that is the node for this connection (office in a building, employee of an office)
     * @type {string}
     * @memberof ConnectionNode
     */
    entityLabel?: string;
    /**
     * Unique ID for the entity that is the node for this connection
     * @type {string}
     * @memberof ConnectionNode
     */
    entityId?: string;
    /**
     * The icon of the organization
     * @type {string}
     * @memberof ConnectionNode
     */
    organizationIcon?: string;
}

export function ConnectionNodeFromJSON(json: any): ConnectionNode {
    return ConnectionNodeFromJSONTyped(json, false);
}

export function ConnectionNodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnectionNode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organizationName': !exists(json, 'organizationName') ? undefined : json['organizationName'],
        'organizationId': !exists(json, 'organizationId') ? undefined : json['organizationId'],
        'entityLabel': !exists(json, 'entityLabel') ? undefined : json['entityLabel'],
        'entityId': !exists(json, 'entityId') ? undefined : json['entityId'],
        'organizationIcon': !exists(json, 'organizationIcon') ? undefined : json['organizationIcon'],
    };
}

export function ConnectionNodeToJSON(value?: ConnectionNode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organizationName': value.organizationName,
        'organizationId': value.organizationId,
        'entityLabel': value.entityLabel,
        'entityId': value.entityId,
        'organizationIcon': value.organizationIcon,
    };
}


